//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'
import CustomStore from 'devextreme/data/custom_store'
import 'devextreme/ui/autocomplete'
import 'devextreme/ui/button'
import 'devextreme/ui/number_box'
import 'devextreme/ui/popup'

//#endregion

import { i18n } from '../i18n/common.i18n'

import { LoggerService } from '../../common/common.module'
import { MapHelper } from '../../../helpers/map-helper'

import { ConfigHelper } from '../../../helpers/config-helper'
import { EventsNames } from '../../../helpers/events-names'
import { IUserSession } from '../../../helpers/user-session'
import { Md5 } from '../../../helpers/md5-helper'

import { Enums } from '../../../models/common/enums'
import { OpLocation } from '../../../models/core/op-location'
import { OpMarker, OpCoord } from '../../../models/custom/op-map-area'

import { MapOptions, Map } from '../map2/map.directive.controller'
import { TemplateHelper } from '../../../helpers'

//#region Asset Imports

import './location-select.scss'
import * as TEMPLATE from './location-select.tpl.html'

//#endregion

var lastTextButtonEvent = null

class LocationData {
    protected _name = null
    _latitude = null
    _longitude = null

    get name() {
        return this._name ? this._name : i18n('Popup', 'LocationNothingSelected')
    }

    set name(str) {
        this._name = str
    }

    get latitude() {
        return this._latitude
    }

    set latitude(value: number) {
        this._latitude = angular.isNumber(value) ? parseFloat(value.toFixed(4)) : null
    }

    get longitude() {
        return this._longitude
    }

    set longitude(value: number) {
        this._longitude = angular.isNumber(value) ? parseFloat(value.toFixed(4)) : null
    }
}

class CurrentLocationData extends LocationData {
    marker: OpMarker
    isChanged: boolean = false

    autoCompleteService = new window['google'].maps.places.AutocompleteService()
    geocoder = new window['google'].maps.Geocoder()
    locationData: any[]
    constructor(private $q: ng.IQService, private $http: ng.IHttpService, private $timeout: ng.ITimeoutService, public map: Map) {
        super()
    }

    get name() {
        return this._name ? this._name : null
    }

    set name(str) {
        this._name = str
    }

    autoCompleteResults = []

    autoCompleteDataSource: DataSource = new DataSource({
        store: new CustomStore({
            load: () => {
                var deferred = $.Deferred<any>()

                if (this._name && this._name != "") {
                    this.autoCompleteService.getQueryPredictions({ input: this._name }, (predictions, status) => {
                        this.autoCompleteResults = []
                        if (predictions)
                            predictions.forEach(prediction => {
                                this.autoCompleteResults.push(prediction)
                            })
                        deferred.resolve(this.autoCompleteResults)
                    })
                } else {
                    this.autoCompleteResults = []
                    deferred.resolve(this.autoCompleteResults)
                }
                return deferred.promise()
            }
        })
    })

    autoCompleteOptions: DevExpress.ui.dxAutocompleteOptions = {
        dataSource: this.autoCompleteDataSource,
        placeholder: i18n('Popup', 'InsertAddress'),
        onValueChanged: (e) => {
            this._name = e.value
        },
        onItemClick: (e) => {
            this.selectLocationByPredictionObject(e.itemData)
        },
        valueExpr: 'description',
        bindingOptions: {
            value: "currentLocation.name"
        }
    }

    latitudeOptions: DevExpress.ui.dxNumberBoxOptions = {
        min: -90,
        max: 90,
        width: '100%',
        placeholder: i18n('Popup', 'InsertLatitude'),
        bindingOptions: {
            value: "currentLocation.latitude"
        },
        onEnterKey: this.updateLocationFromMemory.bind(this),
        onValueChanged: () => {
            this.isChanged = true
        },
        onFocusIn: () => {
            this.isChanged = false
        },
        onFocusOut: () => {
            if (this.isChanged)
                this.updateLocationFromMemory()
        }
    }

    longitudeOptions: DevExpress.ui.dxNumberBoxOptions = {
        min: -180,
        max: 180,
        width: '100%',
        placeholder: i18n('Popup', 'InsertLongitude'),
        bindingOptions: {
            value: "currentLocation.longitude"
        },
        onEnterKey: this.updateLocationFromMemory.bind(this),
        onValueChanged: () => {
            this.isChanged = true
        },
        onFocusIn: () => {
            this.isChanged = false
        },
        onFocusOut: () => {
            if (this.isChanged)
                this.updateLocationFromMemory()
        }
    }

    updateLocationFromMemory() {
        this.$timeout(() => {
            if (angular.isNumber(this.latitude) && angular.isNumber(this.longitude))
                this.updateLocation(this.latitude, this.longitude, true)
        }, 0)
    }

    updateLocation(latitude: number, longitude: number, centerView: boolean = false) {
        this.map.disableMap()
        this.latitude = latitude
        this.longitude = longitude
        this.fetchPlaceAddress().then(() => {
            this.$timeout(() => {
                this.updateMarker(latitude, longitude)
                this.map.enableMap()
                if (centerView) {
                    let coords = new OpCoord()
                    coords.latitude = this.latitude
                    coords.longitude = this.longitude
                    this.map.setCenter(coords)
                    this.map.setZoom(ConfigHelper.getValue(Enums.SimaxConfigSection.Map, ConfigHelper.Key.InitZoom))
                }
            }, 100)
        })
    }

    updateLocationButtonText(latitude: number, longitude: number) {
        this.latitude = latitude
        this.longitude = longitude
        return this.fetchPlaceAddress()
    }

    fetchPlaceAddress() {
        var deferred = this.$q.defer()
        if (angular.isNumber(this.latitude) && angular.isNumber(this.longitude)) {
            this.geocoder.geocode({
                location: { lat: this.latitude, lng: this.longitude }
            }, (result, status) => {
                if (result && result.length > 0) {
                    this.name = result[0].formatted_address
                    this.locationData = result
                }
                else {
                    this.name = this.latitude + ', ' + this.longitude
                }
                deferred.resolve()
            })
        } else {
            deferred.resolve()
        }
        return deferred.promise
    }

    selectLocationByPredictionObject(prediction: any) {
        this.geocoder.geocode({
            placeId: prediction.place_id
        }, (result: any) => {
            if (result == null) {
                return
            }

            this.updateLocation(result[0].geometry.location.lat(), result[0].geometry.location.lng(), true)
        })
    }

    updateMarker(lat: number, lng: number) {
        if (!this.marker) {
            let marker = new OpMarker()
            marker.coords = new OpCoord()
            marker.coords.latitude = lat
            marker.coords.longitude = lng
            this.map.addMarker(marker)
            this.marker = marker
        } else {
            let position = new OpCoord()
            position.latitude = lat
            position.longitude = lng
            this.marker.setPosition(position)
        }
    }

    reset() {
        this.latitude = null
        this.longitude = null
        this.name = null
        let coords = new OpCoord()
        const mapCenter = ConfigHelper.getValue(Enums.SimaxConfigSection.Map, ConfigHelper.Key.Center, { defaultValue: [51.9189046, 19.1343787] })
        coords.latitude = mapCenter[0]
        coords.longitude = mapCenter[1]
        this.map.setCenter(coords)
        const mapZoom = ConfigHelper.getValue(Enums.SimaxConfigSection.Map, ConfigHelper.Key.InitZoom, { defaultValue: 5 })
        this.map.setZoom(mapZoom)
    }
}

interface LocationSelectScope extends ng.IScope {
    bindedLatitude: number
    bindedLongitude: number
    selectedLocation: LocationData
    currentLocation: CurrentLocationData

    popupOptions: DevExpress.ui.dxPopupOptions
    locationSelectButtonOptions: DevExpress.ui.dxButtonOptions
    submitLocationButtonOptions: DevExpress.ui.dxButtonOptions
    cancelButtonOptions: DevExpress.ui.dxButtonOptions
    popupVisible: boolean
    hidePopup(): void

    mapOptions: MapOptions

    onInit(): void
}

export class LocationSelectDirective implements ng.IDirective {
    selectedLocationMd5: string
    mapDeferred: JQueryDeferred<Map>

    constructor() {

    }
    scope = {
        'loadCoords': '&coords',
        'callback': '&callback'
    }
    restrict = 'E'
    controller = ['$scope', '$q', '$timeout', '$http', 'logger', 'userSession', ($scope: LocationSelectScope, $q: ng.IQService, $timeout: ng.ITimeoutService, $http: ng.IHttpService, logger: LoggerService, userSession: IUserSession) => {
        this.mapDeferred = $.Deferred<Map>()

        $scope.selectedLocation = new LocationData
        $scope.popupVisible = false

        var showPopup = () => {
            $scope.popupVisible = true
            setLocationFromAttribute()
        }

        $scope.hidePopup = () => {
            $scope.popupVisible = false
        }

        $scope.popupOptions = {
            bindingOptions: {
                visible: 'popupVisible'
            },
            title: i18n('Popup', 'SelectingLocation'),
            showTitle: true,
            onShowing: () => {
                this.selectedLocationMd5 = ""
            }
        }

        MapHelper
            .getDefaultOptions(userSession.getDataProvider())
            .then((mapOptions: MapOptions) => {
                mapOptions.onMapInit = (map: Map) => {
                    if ($scope.currentLocation != null) {
                        $scope.currentLocation.map = map
                    }
                    else {
                        $scope.currentLocation = new CurrentLocationData($q, $http, $timeout, map)
                    }

                    this.mapDeferred.resolve(map)
                    setLocationFromAttribute()
                }

                mapOptions.onMapClick = (position: OpCoord) => {
                    $scope.currentLocation.updateLocation(position.latitude, position.longitude)
                },

                    mapOptions.hideLegend = true
                mapOptions.hideCounter = true
                mapOptions.hideCloseButton = true,

                    $scope.mapOptions = mapOptions
            })

        var selectLocation = () => {
            $scope.selectedLocation.name = $scope.currentLocation.name
            $scope.selectedLocation.latitude = $scope.currentLocation.latitude
            $scope.selectedLocation.longitude = $scope.currentLocation.longitude
            var currentMd5 = Md5.init($scope.selectedLocation)
            if (this.selectedLocationMd5 !== currentMd5) {
                $scope['callback']()($scope.selectedLocation.latitude, $scope.selectedLocation.longitude)
                this.selectedLocationMd5 = currentMd5
            }
            $scope.hidePopup()
            if ($scope.currentLocation.locationData) {
                $scope.$root.$broadcast(EventsNames.LOCATION_SELECTED_GMAP, $scope.currentLocation.locationData)
            }
        }

        var cancel = () => {
            $scope.hidePopup()
        }

        var setLocationFromAttribute = () => {
            this.mapDeferred.promise().then(() => {
                var coords = $scope['loadCoords'] ? $scope['loadCoords']() : null
                if (coords) {
                    $scope.currentLocation.updateLocation(coords.latitude, coords.longitude, true)
                } else {
                    $scope.currentLocation.reset()
                }
            })
        }

        $scope.locationSelectButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.ADD_LOCATION, userSession),
            hint: i18n('Popup', 'SelectLocation'),
            onClick: showPopup
        }

        $scope.submitLocationButtonOptions = {
            text: i18n('Common', 'Select'),
            onClick: selectLocation
        }

        $scope.cancelButtonOptions = {
            text: i18n('Common', 'Cancel'),
            onClick: cancel
        }

        // DX and angular hack :)
        if (lastTextButtonEvent) {
            lastTextButtonEvent()
        }

        lastTextButtonEvent = $scope.$on(EventsNames.UPDATE_COORDINATES_BUTTON_POPUP, (event: ng.IAngularEvent, ...args: any[]) => {
            if (args[0] && angular.isNumber(args[0].latitude) && angular.isNumber(args[0].longitude)) {
                $scope.currentLocation.updateLocationButtonText(args[0].latitude, args[0].longitude).then(() => {
                    $scope.selectedLocation.name = $scope.currentLocation.name
                    $scope.selectedLocation.latitude = $scope.currentLocation.latitude
                    $scope.selectedLocation.longitude = $scope.currentLocation.longitude
                })
            } else {
                $scope.selectedLocation.name = undefined
            }
        })

        const currentCoords: OpCoord = $scope['loadCoords'] ? $scope['loadCoords']() : null

        if (currentCoords && currentCoords.latitude && currentCoords.longitude) {
            $scope.currentLocation = new CurrentLocationData($q, $http, $timeout, null)
            $scope.currentLocation.latitude = currentCoords.latitude
            $scope.currentLocation.longitude = currentCoords.longitude

            $scope.currentLocation
                .fetchPlaceAddress()
                .then((x: any) => {

                    $scope.selectedLocation.name = $scope.currentLocation.name
                    $scope.selectedLocation.latitude = $scope.currentLocation.latitude
                    $scope.selectedLocation.longitude = $scope.currentLocation.longitude

                    const gmapLocationInfo: any = $scope.currentLocation.locationData

                    let city: string
                    let address: string
                    let street: string
                    let nbr: string
                    let zip: string

                    let loc: OpLocation = null

                    if (gmapLocationInfo != null) {
                        try {
                            gmapLocationInfo[0].address_components.forEach(item => {
                                if (item.types.indexOf('locality') > -1)
                                    city = item.long_name
                                if (item.types.indexOf('route') > -1)
                                    street = item.long_name
                                if (item.types.indexOf('street_number') > -1)
                                    nbr = item.long_name
                                if (item.types.indexOf('postal_code') > -1 && item.types.indexOf('postal_code_prefix') === -1)
                                    zip = item.long_name
                            })

                            address = street || ''

                            if (street && nbr) {
                                address += (', ' + nbr)
                            }

                            if (!zip || zip.length < 3) {
                                gmapLocationInfo.forEach(info => {
                                    if (info.types.indexOf('postal_code') > -1 && info.types.indexOf('postal_code_prefix') === -1) {
                                        info.address_components.forEach(item => {
                                            item.types.forEach(type => {
                                                if (type === 'postal_code')
                                                    zip = item.long_name
                                            })
                                        })
                                    }
                                })
                            }

                            loc = new OpLocation(null)
                            loc.name = $scope.selectedLocation.name
                            loc.latitude = $scope.selectedLocation.latitude
                            loc.longitude = $scope.selectedLocation.longitude
                            loc.city = city
                            loc.address = address
                            loc.postalCode = zip

                        } catch (e) {
                            console.error(`Failed to determine location details: ${e}`)
                        }
                    }

                    $scope.$root.$broadcast(EventsNames.LOCATION_SELECT_INITIALIZED, loc)
                })
        }
    }]

    template = TEMPLATE
    replace = true
}
